export default __webpack_public_path__ + "static/media/documents-icon.e91c34c2.svg";